import React, { Component } from 'react';
import { connect } from 'react-redux';
import debounce from 'debounce';

import Dropdown from './../Dropdown';

import { userSetFieldFetch } from './../../store/user/actions';

const fieldName = 'skype';

class SkypeDropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: ''
        };

        this.onChange = this.onChange.bind(this);
        this.debounceSave = debounce(this.debounceSave, 1000);
    }

    onChange(event) {
        const inputValue = event.target.value;
        this.setState({ inputValue });
        const { save } = this.props;
        this.debounceSave(inputValue, save);
    }

    debounceSave(value, method) {
        method(value);
    }

    componentDidMount() {
        const { value } = this.props;
        this.setState({ inputValue: value });
    }

    render() {
        const { inputValue } = this.state;
        const text = inputValue || 'Enter skype';
        return (
            <Dropdown buttonClassName="lnk-dropdown" text={text} title={text}>
                <input className="input-text" type="tel" maxLength="100" onChange={this.onChange} autoFocus value={inputValue} placeholder="Enter your skype" />
            </Dropdown>
        );
    }
}
const mapStateToProps = state => ({
    value: state.user[fieldName]
});
const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch(fieldName, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(SkypeDropdown);


// WEBPACK FOOTER //
// ./src/components/profile/SkypeDropdown.js